import {
  STEP_BOOKING,
  STEP_CAR_HIRE_DETAILS,
  STEP_CAR_HIRE_RESULTS,
  STEP_FLIGHT_RESULTS,
  STEP_HOTEL_DETAILS,
  STEP_HOTEL_RESULTS,
  STEP_HOTEL_ROOM,
} from './travel.data';

export const isCompleteMap: { [key: string]: string } = {
  [STEP_FLIGHT_RESULTS]: 'is_flight_results_complete',
  [STEP_HOTEL_RESULTS]: 'is_hotel_results_complete',
  [STEP_HOTEL_ROOM]: 'is_hotel_room_complete',
  [STEP_HOTEL_DETAILS]: 'is_hotel_details_complete',
  [STEP_CAR_HIRE_RESULTS]: 'is_car_hire_results_complete',
  [STEP_CAR_HIRE_DETAILS]: 'is_car_hire_details_complete',
  [STEP_BOOKING]: 'is_booking_complete',
};

export interface FlightSteps {
  title: string;
  isActive: boolean;
  isComplete: boolean;
  children: {
    title: string;
    key: string;
    isComplete: boolean;
    isCurrent: boolean;
  }[];
}

export const flightSteps: FlightSteps = {
  title: 'Flights',
  isActive: false,
  isComplete: false,
  children: [
    {
      title: 'Results',
      key: STEP_FLIGHT_RESULTS,
      isComplete: false,
      isCurrent: false,
    },
  ],
};

export const hotelSteps = {
  title: 'Hotels',
  isActive: false,
  isComplete: false,
  children: [
    {
      title: 'Results',
      key: STEP_HOTEL_RESULTS,
      isComplete: false,
      isCurrent: false,
    },
    {
      title: 'Room',
      key: STEP_HOTEL_ROOM,
      isComplete: false,
      isCurrent: false,
    },
    {
      title: 'Details',
      key: STEP_HOTEL_DETAILS,
      isComplete: false,
      isCurrent: false,
    },
  ],
};

export const carSteps = {
  title: 'Car Rental',
  isActive: false,
  isComplete: false,
  children: [
    {
      title: 'Results',
      key: STEP_CAR_HIRE_RESULTS,
      isComplete: false,
      isCurrent: false,
    },
    {
      title: 'Details',
      key: STEP_CAR_HIRE_DETAILS,
      isComplete: false,
      isCurrent: false,
    },
  ],
};

export const bookingSteps = {
  title: 'Confirm',
  isActive: false,
  isComplete: false,
  isBooking: true,
  children: [
    {
      title: 'Booking',
      key: STEP_BOOKING,
      isComplete: false,
      isCurrent: false,
    },
  ],
};
